import { render } from "./ReasonPopover.vue?vue&type=template&id=9228a780&scoped=true&ts=true"
import script from "./ReasonPopover.vue?vue&type=script&lang=ts"
export * from "./ReasonPopover.vue?vue&type=script&lang=ts"

import "./ReasonPopover.vue?vue&type=style&index=0&id=9228a780&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9228a780"]])

export default __exports__